import React, { useEffect } from 'react';
import LoginForm from '@/components/LoginForm';
import IntellendLogo from '@/components/IntellendLogo';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
	const { user, loadingUser } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		// If user is already logged in as staff/admin or has Admin Login permission, redirect to dashboard
		const hasAdminPermission = user?.permissions?.includes("Admin Login");
		if (!loadingUser && user && (user.is_staff || user.is_superuser || hasAdminPermission)) {
			navigate('/admin-dashboard');
		}
	}, [user, loadingUser, navigate]);

	if (loadingUser) {
		return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
	}

	return (
		<div className="min-h-screen bg-[#FAF9F6] flex flex-col items-center justify-center p-4">
			<div className="mb-8 flex flex-col items-center">
				<IntellendLogo size="lg" className="mb-4" />
				<h1 className="text-3xl font-bold text-gray-900">Admin Portal</h1>
				<p className="text-gray-600 mt-2">Sign in to manage the platform</p>
			</div>

			<div className="w-full max-w-md">
				<LoginForm isAdminMode={true} />
			</div>

			<div className="mt-8 text-center text-sm text-gray-500">
				<p>&copy; {new Date().getFullYear()} Intellend. All rights reserved.</p>
			</div>
		</div>
	);
};

export default AdminLogin;
